// extracted by mini-css-extract-plugin
export default {"headerContent":"_3cpUM","title":"_1amxr"};